import React, { useState } from 'react';
import PasswordWidget from './Modulos/PasswordWidget';
import { useUsuarioCreacionModel } from '../../modelos/Usuario/modeloUsuario';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';

const RegistroCliente = () => {
// Estado local del formulario
  const [formData, setFormData] = useState({
    nombrecompletoCliente: '',
    correoElectronico: '',
    numero: '',
    contrasena: '',
    confirmarContrasena: ''
  });

  // Manejador de cambios genérico
  const handleChange = (e) => {
    const { name, value } = e.target;
    
    // Validación simple para celular (solo números)
    if (name === 'numero' && !/^\d*$/.test(value)) return;

    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const navigate = useNavigate();

  //impportar modelo
  const {
    nuevoCliente,
    verificarPreRegistro,
  } = useUsuarioCreacionModel();

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // Validación final de contraseñas antes de enviar
    if (formData.contrasena !== formData.confirmarContrasena) {
      alert("Las contraseñas no coinciden");
      return;
    }

    const resultado = await verificarPreRegistro(formData);

    console.log("el resultado es",resultado);
    console.log("action",resultado.caso);
    if (!resultado) return;

    switch (resultado.caso) {
        case 'NUEVO_USUARIO':
            toast.info(resultado.mensaje);
            
            //vamos a verificar correo
            navigate('verificar-correo', { 
                state: { datosPendientes: formData } 
            });
            
            break;
        case 'VERIFICAR_POR_NUMERO':
            toast.info(resultado.mensaje);
            
            /*
            navigate('verificar-whatsapp', { 
                state: { datosPendientes: formData } 
            });
            */

             navigate('verificar-correo', { 
                state: { datosPendientes: formData } 
            });
            
            break;

        case 'VERIFICAR_POR_CORREO':
            toast.info(resultado.mensaje);
            
            navigate('verificar-correo', { 
                state: { datosPendientes: formData } 
            });
            
            break;
            
        case 'CONFLICTO_DATOS':
            toast.error(resultado.error); 
            break;

        default:
            toast.error("Respuesta inesperada del servidor");
    }
    
  };

  return (
    <div className="flex justify-center items-center min-h-screen bg-gray-100 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-2xl w-full bg-white rounded-lg shadow-xl overflow-hidden">
        
        {/* Header - Mismo diseño EduSmart */}
        <div className="bg-blue-600 text-white p-6 flex justify-between items-center shadow-md">
          <div className="text-xl opacity-80">∑ ÷ ∞</div>
          <h1 className="text-3xl md:text-4xl font-bold tracking-tight">EduSmart</h1>
          <div className="text-xl opacity-80">🎓 📚</div>
        </div>

        {/* Cuerpo del Formulario */}
        <div className="p-8">
          <div className="mb-8 text-center sm:text-left">
            <h2 className="text-2xl font-bold text-gray-800">Crear Cuenta</h2>
            <p className="text-sm text-gray-500 mt-1">
              Complete sus datos personales para registrarse en la plataforma.
            </p>
          </div>

          <form onSubmit={handleSubmit} className="space-y-6" autoComplete="off">
            
            {/* Nombre Completo */}
            <div className="flex flex-col">
              <label className="mb-1 flex items-center font-medium text-gray-700">
                Nombre Completo:
                <span className="text-red-500 ml-1">*</span>
              </label>
              <input
                type="text"
                name="nombrecompletoCliente"
                value={formData.nombrecompletoCliente}
                onChange={handleChange}
                placeholder="Ej: Andrés Ramírez"
                className="p-2 border border-gray-300 rounded w-full focus:outline-none focus:ring-2 focus:ring-blue-500 transition-all"
                required
              />
            </div>

            {/* Correo Electrónico */}
            <div className="flex flex-col">
              <label className="mb-1 flex items-center font-medium text-gray-700">
                Correo Electrónico:
                <span className="text-red-500 ml-1">*</span>
              </label>
              <input
                type="email"
                name="correoElectronico"
                value={formData.correoElectronico}
                onChange={handleChange}
                placeholder="Ej: usuario@ejemplo.com"
                className="p-2 border border-gray-300 rounded w-full focus:outline-none focus:ring-2 focus:ring-blue-500 transition-all"
                required
                autoComplete="email"
              />
            </div>

            {/* Número de Celular */}
            <div className="flex flex-col">
              <label className="mb-1 flex items-center font-medium text-gray-700">
                Número de Celular:
                <span className="text-red-500 ml-1">*</span>
              </label>
              <input
                type="tel"
                name="numero"
                value={formData.numero}
                onChange={handleChange}
                placeholder="Ej: 3161234567"
                className="p-2 border border-gray-300 rounded w-full focus:outline-none focus:ring-2 focus:ring-blue-500 transition-all"
                required
                maxLength={12} 
                minLength={12}
              />
              <p className="text-xs text-gray-400 mt-1">Ingrese solo números (10 dígitos)</p>
            </div>

            {/* WIDGET DE CONTRASEÑA REUTILIZADO */}
            <PasswordWidget
              password={formData.contrasena}
              confirmPassword={formData.confirmarContrasena}
              onChange={handleChange}
              namePassword="contrasena"
              nameConfirm="confirmarContrasena"
            />

            {/* Términos y Botón */}
            <div className="pt-4">
              <div className="flex items-center mb-6">
                <input
                  id="terms"
                  type="checkbox"
                  required
                  className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded cursor-pointer"
                />
                <label htmlFor="terms" className="ml-2 block text-sm text-gray-900 cursor-pointer">
                  Acepto los <span className="text-blue-600 hover:underline">términos y condiciones</span>
                </label>
              </div>

              <button
                type="submit"
                className="w-full bg-blue-600 hover:bg-blue-700 text-white font-bold py-3 px-4 rounded-full shadow-lg transform transition hover:-translate-y-0.5 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
              >
                Registrarme
              </button>
            </div>

          </form>
        </div>
      </div>
    </div>
  );
};

export default RegistroCliente
